import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { CurrencyEnum } from '../../../../lib/enums/currency.enum';
import { OrderSideEnum } from '../../../../lib/enums/order-side.enum';
import lang from '../../../../lib/language';
import { FXType } from '../../../../lib/models/trading/types';
import { newFXOrder } from '../../../../lib/store/trading/index';
import { formatNumber } from '../../../../lib/util/DataHelpers';
import { isWithinDowntime } from '../../../../lib/util/DateTimeHelpers';

import { ButtonTypesEnum } from '../../../../components/Button/Button.types';
import { BaseModal, Button } from '../../../../components/index';
import FXOrder from '../../components/FXOrder/FXOrder';
import ReviewFXExchange from '../../components/ReviewOrder/ReviewFXExchange';

import FXStatusTime from './FXStatusTime/FXStatusTime';

import styles from './styles.module.scss';

type Props = {
    isOpen: boolean;
    closeModal: () => void;
    setQuantity: (value: number) => void;
    setOrderSide: (value: OrderSideEnum) => void;
    setIsOrderCreated: (value: boolean) => void;
}

const FXOrderModal = ({ isOpen, closeModal, setQuantity, setOrderSide, setIsOrderCreated }: Props) => {
  const dispatch = useDispatch();
  const [showReview, setShowReview] = useState<boolean>(false);
  const [usdValue, setUsdValue] = useState<string>('');
  const [eurValue, setEurValue] = useState<string>('');
  const [currentSide, setCurrentSide] = useState<OrderSideEnum>(OrderSideEnum.Sell);
  const [isDowntime, setIsDowntime] = useState<boolean>(isWithinDowntime());

  useEffect(() => {
    if (!isOpen) return;
    // TODO: cover this part with unit tests
    const intervalId = setInterval(() => {
      const downtime = isWithinDowntime();
      if (downtime !== isDowntime) {
        setIsDowntime(downtime);
        clearInterval(intervalId); // Stop checking if the downtime status changes
      }
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(intervalId);
    };
  }, [isOpen, isDowntime]);
  const confirmOrder = () => {
    const quantity = Number(eurValue);
    setShowReview(false);
    setIsOrderCreated(true);
    setQuantity(quantity);
    setOrderSide(currentSide);

    dispatch(newFXOrder({
      quantity,
      currency: CurrencyEnum.EUR,
      side: currentSide,
      symbol: 'EUR/USD',
      settlCurrency: CurrencyEnum.USD,
      type: FXType.ForexMarket,
    }));
  };

  return (
    <>
      <BaseModal isOpen={isOpen}>
        { isDowntime ? (
          <>
            <FXStatusTime />
            <Button
              className={styles.button}
              fullWidth
              variant={ButtonTypesEnum.Primary}
              onClick={closeModal}
            >
              {lang.commonGoBackBtn()}
            </Button>
          </>
        ) : (
          <FXOrder
            reviewButtonStyle={styles.button}
            showReviewModal={showReview}
            setShowReviewModal={() => setShowReview(true)}
            setOrderSide={side => setCurrentSide(side)}
            setEurCurrnecy={value => setEurValue(value)}
            setUsdCurrnecy={value => setUsdValue(value)}
            closeOrderModal={closeModal}
          >
            <Button
              className={styles.button}
              fullWidth
              variant={ButtonTypesEnum.Tertiary}
              onClick={closeModal}
            >
              {lang.commonCancelButton()}
            </Button>
          </FXOrder>
        )}
      </BaseModal>
      <BaseModal isOpen={showReview} className={styles.reviewModal}>
        <ReviewFXExchange
          side={currentSide}
          eurAmount={`€ ${formatNumber(eurValue)}`}
          usdAmount={`$ ${formatNumber(usdValue)}`}
          handleConfirmOrder={confirmOrder}
          handleCancel={() => setShowReview(false)}
        />
      </BaseModal>
    </>
  );
};

export default FXOrderModal;
